import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DetailIcon from '@mui/icons-material/Details';
import ActivateIcon from '@mui/icons-material/CheckCircle'; // Import the activate icon
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// import { saveData, getData, openDB } from '../../../utils/db';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';


function UserIndex() {
  const [data, setData] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const { isAuthenticated, companyId, userId, logout, token, permissions } = useAuth();

  useEffect(() => {
    // Check if the token is expired
    if (isAuthenticated && tokenIsExpired(token)) {
      // Token is expired, log out the user
      logout();
      return;
    }

  }, [isAuthenticated, companyId, token, logout]);
  const hasCreateAdministrationPermission = permissions.includes('Create Administration');
  const hasEditAdministrationPermission = permissions.includes('Edit Administration');
  const hasDeleteAdministrationPermission = permissions.includes('Delete Administration');
  useEffect(() => {
    fetchtableData();
  }, []);


  const fetchtableData = async () => {

    fetchData('UserApi', `/${companyId}`, token)
      .then((response) => {
        if (response.responseCode == '1111') {
          console.log(response);
          setData(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching User Details:', error);
      });


  };



  const handleDelete = async () => {
    deleteData('UserApi', `${deleteItemId}`, token)
      .then((response) => {
        fetchtableData(); // Refresh data after deletion
        setDeleteItemId(null); // Reset the item ID
        setConfirmDialogOpen(false); // Close the dialog
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
      });

  };

  const handleActivate = (itemId) => {
    activateData('UserApi', `${itemId}`, token)
      .then((response) => {
        fetchtableData(); // Refresh data after deletion
      })
      .catch((error) => {
        // Handle errors for the activation request
      });
  };

  const openConfirmDialog = (itemId) => {
    setDeleteItemId(itemId);
    setConfirmDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setDeleteItemId(null);
    setConfirmDialogOpen(false);
  };

  return (
    <div className="w-full max-w-sm container mt-6 mx-auto" style={{ maxWidth: '98%' }}>
      <div className='w-full mb-2 flex'>
        <h6 className='uppercase productHead flex-grow linkcolor' style={{ fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bolder' }}>User</h6>
        {/* {hasCreateAdministrationPermission && ( */}

        <Tooltip title="Create New Company">
          <Link to="/userCreate" className="inline-block">
            <Button
              style={{
                background: 'linear-gradient(to right, darkslategray, slategray)',
                borderRadius: '50px',
                padding: '10px 20px',
                color: 'white',
                fontWeight: 'bolder',
                textTransform: 'none',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                maxHeight: '35px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <AddIcon style={{ fontWeight: 'bolder' }} /> Create
            </Button>
          </Link>
        </Tooltip>
        {/* )} */}
      </div>

      <div className='w-full mb-5 flex' style={{ maxHeight: '450px', overflowY: 'auto' }}>
        <TableContainer component={Paper}>
          <Table>
            {/* <TableHead sx={{ backgroundColor: '#f3f3f3' }}> */}
            <TableHead sx={{ backgroundColor: '#0B5345' }}>
              <TableRow>
                <TableCell sx={{ borderBottom: '1px solid #ddd', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px' }} style={{ width: '230px' }}>First Name</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px' }} style={{ width: '230px' }}>Last Name</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px' }} style={{ width: '230px' }}>User Name</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px' }} style={{ width: '180px' }}>Co.Number</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px' }} style={{ width: '180px' }}>Email</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px', textAlign: 'center' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            {/* <TableBody> */}
            <TableBody sx={{ backgroundColor: 'white' }}>
              {data.map(item => (
                <TableRow key={item.Id} className={item.IsActive ? '' : 'inactiveRow'}>
                  <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '14px', padding: '3px' }}>{item.FirstName}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '14px', padding: '3px' }}>{item.LastName}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '14px', padding: '3px' }}>{item.UserName}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '14px', padding: '3px' }}>{item.ContactNumber}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '14px', padding: '3px' }}>{item.Email}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '14px', padding: '3px', textAlign: 'right' }}>

                    <Link to={`/userDetail/${item.Id}`}>
                      <IconButton>
                        <DetailIcon style={{ color: 'darkgoldenrod' }} />
                      </IconButton>
                    </Link>

                    {hasEditAdministrationPermission && (
                      <Link to={`/userEdit/${item.Id}`}>
                        <IconButton>
                          <EditIcon style={{ color: 'blueviolet' }} />
                        </IconButton>
                      </Link>
                    )}

                    {hasDeleteAdministrationPermission && (
                      <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))}>
                        {item.IsActive ? <DeleteIcon style={{ color: 'brown' }} /> : <ActivateIcon />}
                      </IconButton>
                    )}

                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            {/* Delete confirmation dialog */}
            <Dialog
              open={confirmDialogOpen}
              onClose={closeConfirmDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to delete this record?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <button
                  onClick={closeConfirmDialog}
                  style={{
                    backgroundColor: '#dc3545',
                    color: '#ffffff',
                    border: '1px solid #dc3545',
                    borderRadius: '4px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    marginRight: '8px',
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleDelete}
                  style={{
                    backgroundColor: '#28a745',
                    color: '#ffffff',
                    border: '1px solid #28a745',
                    borderRadius: '4px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                  }}
                >
                  Confirm
                </button>
              </DialogActions>
            </Dialog>
          </Table>
        </TableContainer>
      </div>
    </div>

  );
}

export default UserIndex;

